jQuery(window).on("load resize", function () {
  jQuery('.grid-with-content .container .row .col-three').sameHeight();
});            